<div class="icon {{ className }}">
  <img #imgRef class="{{icon}}" [src]="patch" [alt]="icon">
</div>

